function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 10.875S17.25 4 11 4 1 10.875 1 10.875s3.75 6.875 10 6.875 10-6.875 10-6.875zm-18.534 0c.605.919 1.3 1.774 2.075 2.554C6.15 15.04 8.35 16.5 11 16.5c2.65 0 4.849-1.46 6.46-3.071.775-.78 1.47-1.635 2.075-2.554a16.42 16.42 0 00-2.075-2.554C15.849 6.71 13.649 5.25 11 5.25c-2.65 0-4.849 1.46-6.46 3.071-.775.78-1.47 1.635-2.075 2.554h.001z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 7.75A3.125 3.125 0 1011 14a3.125 3.125 0 000-6.25zm-4.375 3.125a4.375 4.375 0 118.75 0 4.375 4.375 0 01-8.75 0z"
});
function SvgEyeShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref, _ref2);
}
export default SvgEyeShow;